export default "__VITE_ASSET__mhi3O9oT__"